import axios from 'axios';

import { GenReportReq, ReqReportData } from '@/models/report';
import { SaveDataFile } from '@/helpers/SaveDataFile';

// auth http client using firebase token
const bReporting = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,

  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

const dataOnly = (v: any) => v.data.data;

const service = {
  http: bReporting,

  setToken(token: string) {
    this.http.defaults.headers.Authorization = 'token ' + token;
  },

  async RequestReportGeneration(req: GenReportReq) {
    return dataOnly(await this.http.post('/reporting/gen', req));
  },

  async RequestReportData(req: ReqReportData) {
    return dataOnly(await this.http.post('/admin/reporting/data', req));
  },

  async downloadExport(req: ReqReportData) {
    const data = await this.http.request({
      url: `/admin/reporting/export`,
      method: 'POST',
      responseType: 'blob',
      data: req,
    });
    const fileName = `export_${req.name}.xlsx`;
    SaveDataFile(data.data, fileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml");
  },
};

export default service;
